import React, { useState } from "react";

import { Tab, TabList, Tabs, Text } from "@chakra-ui/react";

import { Option } from "../../Types";

export type ToggleProps = {
  options: Option[];
  size: "sm" | "md" | "lg";
  onChange: (key: string) => void;
};

const Toggle: React.FC<ToggleProps> = ({ options, size, onChange }) => {
  const [toggleIndex, setToggleIndex] = useState(0);

  const handleToggleChange = (index: number) => {
    setToggleIndex(index);
    onChange(options[index].key);
  };

  return (
    <Tabs
      variant="unstyled"
      size={size}
      w="fit-content"
      h="fit-content"
      borderRadius="full"
      index={toggleIndex}
      onChange={handleToggleChange}
    >
      <TabList h="100%">
        {options.map((option, index) => (
          <Tab
            key={option.key + option.value + index}
            borderRadius="6px"
            color="text-secondary"
            fontSize={size}
            fontWeight={600}
            _hover={{ color: "white", bg: "surface-highlight" }}
            _selected={{ color: "white", bg: "primary-default" }}
            _focus={{ outline: "none" }}
          >
            <Text>{option.value}</Text>
          </Tab>
        ))}
      </TabList>
    </Tabs>
  );
};

export default Toggle;
